import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=542d107a&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=542d107a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d107a",
  null
  
)

export default component.exports